import {
  ALL_RELATIONS,
  ALL_RELATION_PAIRS,
  catalogGraphApiRef,
  DefaultCatalogGraphApi,
} from '@backstage/plugin-catalog-graph';
import {
  CUSTOM_RELATION_PAIRS,
  RELATION_SCAFFOLDED_BY,
  RELATION_SCAFFOLDER_OF,
} from '@developer-portal/plugin-catalog-common';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

export const catalogGraphPluginOverrides = createFrontendModule({
  pluginId: 'catalog-graph',
  extensions: [
    catalogGraphPlugin.getExtension('api:catalog-graph').override({
      params: defineParams =>
        defineParams({
          api: catalogGraphApiRef,
          deps: {},
          factory: () =>
            new DefaultCatalogGraphApi({
              knownRelations: [...ALL_RELATIONS, RELATION_SCAFFOLDED_BY, RELATION_SCAFFOLDER_OF],
              knownRelationPairs: [...ALL_RELATION_PAIRS, ...CUSTOM_RELATION_PAIRS],
              defaultRelationTypes: { exclude: [] },
            }),
        }),
    }),
  ],
});
